import { SearchField } from '@bechtel/client-common';
import { Box, Button, IconSize, TextFieldSize } from '@bechtel/gds';
import { Scalars } from '@bechtel/types';
import styled, { css } from 'styled-components';
import { weekPlanHeaderHeight } from '../../weekplancard/styled';

interface BacklogHeaderContainerProps {
  isDisableHeader: boolean;
}

export const SearchFieldStyled = styled(SearchField).attrs({ size: TextFieldSize.SMALL, iconSize: IconSize.SMALL })`
  ${({ theme }) => css`
    border-color: ${theme.colors.grey[300]};
  `}
`;

export const BacklogHeaderContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  px: { sm: '400' },
  py: { sm: '500' },
})<BacklogHeaderContainerProps>`
  height: ${weekPlanHeaderHeight};
  ${(props) =>
    props.isDisableHeader &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}
`;

export const SeperatorStyled = styled(Box).attrs({
  mt: { sm: '400' },
  mb: { sm: '400' },
})`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.grey[300]};
`;

interface SearchCanvasButtonStyledProps {
  isDefaultFilterChange: Scalars['Boolean'];
}
export const SearchCanvasButtonStyled = styled(Button)<SearchCanvasButtonStyledProps>`
  ${(props) =>
    props.isDefaultFilterChange &&
    css`
      background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      &:hover {
        background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      }
    `}
`;
